/** Manages subtask-specific actions for the task list. */
import { useState, useCallback } from 'react';

export const useTaskListSubtaskActions = ({
  allTasks,
  user,
  updateTask,
  handleAddTask,
  deselectAllTasks,
  onStopEditing,
}) => {
  const [addingSubtaskTo, setAddingSubtaskTo] = useState(null);

  const handleStartAddingSubtask = useCallback(
    (parentId) => {
      deselectAllTasks();
      onStopEditing();
      setAddingSubtaskTo(parentId);
    },
    [deselectAllTasks, onStopEditing],
  );

  const handleCancelAddSubtask = useCallback(
    () => setAddingSubtaskTo(null),
    [],
  );

  const handleSaveSubtask = useCallback(
    async (taskData) => {
      if (!addingSubtaskTo) return;
      const parentId = addingSubtaskTo;
      // We sluiten de input niet meer automatisch af
      // setAddingSubtaskTo(null);

      try {
        const parentTask = allTasks.find((t) => t.id === parentId);
        if (parentTask && (parentTask.date || parentTask.time)) {
          try {
            await updateTask(parentId, { date: null, time: null }, user?.uid);
          } catch (e) {
            console.error('Failed to clear parent date:', e);
          }
        }
        await handleAddTask({ ...taskData, parentId });
      } catch (error) {
        console.error('Failed to add subtask:', error);
      }
    },
    [addingSubtaskTo, allTasks, updateTask, user, handleAddTask],
  );

  return {
    addingSubtaskTo,
    handleStartAddingSubtask,
    handleCancelAddSubtask,
    handleSaveSubtask,
  };
};
